import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { Toaster } from './components/ui/toaster';

const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
    <Toaster />
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}
